// api/patientAppointmentsApi.js
import api from "./axios";

// Reuse this list anywhere you need a zone selector
export const ZONES = [
  "America/New_York",
  "America/Chicago",
  "America/Denver",
  "America/Los_Angeles",
  "UTC",
];

const BASE_PATH = "/api/v1/appointments";

/**
 * Fetch Patient “cards” (provider info + appt window) for a single date.
 * Mirrors: GET /api/appointments/patient/{patientId}/by-date/cards
 *
 * @param {object} args
 * @param {number|string} args.patientId          Required
 * @param {string} args.date                      Required, yyyy-MM-dd (e.g. "2025-09-17")
 * @param {string} [args.zone="America/New_York"] Optional IANA TZ (e.g. "America/New_York")
 * @param {string[]} [args.states=[]]             Optional states, e.g. ["SCHEDULED","COMPLETED"]
 * @param {number} [args.page=0]                  Optional page index
 * @param {number} [args.size=100]                Optional page size
 * @returns {Promise<object>}                     Page<PatientApptProviderCard>
 *
 * Expected page.content items (as your backend maps them):
 * {
 *   firstName: string,
 *   lastName: string,
 *   email: string,
 *   phoneNumber: string,
 *   appointmentId: number,
 *   appointmentStart: string,  // or ISO date-time if you return temporal types
 *   appointmentEnd: string
 * }
 */
export async function fetchPatientAppointmentCardsByDate({
  patientId,
  date,
  zone = "America/New_York",
  states = [],
  page = 0,
  size = 100,
}) {
  if (!patientId) throw new Error("patientId is required");
  if (!date) throw new Error("date (yyyy-MM-dd) is required");

  const params = {
    date,
    zone,
    page,
    size,
  };

  if (states && states.length) {
    // Spring @RequestParam List<AppointmentState> can parse CSV
    params.states = states.join(",");
  }

  const res = await api.get(`${BASE_PATH}/patient/${patientId}/by-date/cards`, {
    params,
  });

  return res.data;
}

// ---- cancel appointment (patient) ----
export async function cancelAppointmentPatient({
  appointmentId,
  patientId,
  reason,
}) {
  if (!appointmentId) throw new Error("appointmentId is required");
  if (!patientId) throw new Error("patientId is required");
  if (!reason || !reason.trim())
    throw new Error("Cancellation reason is required");

  await api.post(`${BASE_PATH}/${appointmentId}/cancel/patient/${patientId}`, {
    reason: reason.trim(),
  });
}
